import ColorChunk from '/opt/buildhome/repo/.dumi/theme/builtins/ColorChunk/index.tsx';
import API from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/API/index.js';
import Badge from '/opt/buildhome/repo/.dumi/theme/builtins/Badge/index.tsx';
import CodeGroup from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/CodeGroup/index.js';
import Container from '/opt/buildhome/repo/.dumi/theme/builtins/Container/index.tsx';
import Previewer from '/opt/buildhome/repo/.dumi/theme/builtins/Previewer/index.tsx';
import SourceCode from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/SourceCode/index.js';
import Table from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Table/index.js';
import Tree from '/opt/buildhome/repo/node_modules/dumi/theme-default/builtins/Tree/index.js';
import Antd from '/opt/buildhome/repo/.dumi/theme/builtins/Antd.tsx';
import APITable from '/opt/buildhome/repo/.dumi/theme/builtins/APITable/index.tsx';
import Audio from '/opt/buildhome/repo/.dumi/theme/builtins/Audio/index.tsx';
import ColorPalettes from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPalettes/index.ts';
import ColorPaletteTool from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteTool/index.ts';
import ColorPaletteToolDark from '/opt/buildhome/repo/.dumi/theme/builtins/ColorPaletteToolDark/index.ts';
import ComponentMeta from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentMeta/index.tsx';
import ComponentOverview from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentOverview/index.tsx';
import ComponentTokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/ComponentTokenTable/index.tsx';
import DemoWrapper from '/opt/buildhome/repo/.dumi/theme/builtins/DemoWrapper/index.tsx';
import IconSearch from '/opt/buildhome/repo/.dumi/theme/builtins/IconSearch/index.tsx';
import ImagePreview from '/opt/buildhome/repo/.dumi/theme/builtins/ImagePreview/index.tsx';
import InlinePopover from '/opt/buildhome/repo/.dumi/theme/builtins/InlinePopover/index.tsx';
import InstallDependencies from '/opt/buildhome/repo/.dumi/theme/builtins/InstallDependencies/index.tsx';
import LocaleLink from '/opt/buildhome/repo/.dumi/theme/builtins/LocaleLink/index.tsx';
import Palette from '/opt/buildhome/repo/.dumi/theme/builtins/Palette/index.ts';
import ResourceCards from '/opt/buildhome/repo/.dumi/theme/builtins/ResourceCards/index.tsx';
import Sandpack from '/opt/buildhome/repo/.dumi/theme/builtins/Sandpack/index.tsx';
import TokenCompare from '/opt/buildhome/repo/.dumi/theme/builtins/TokenCompare/index.tsx';
import TokenTable from '/opt/buildhome/repo/.dumi/theme/builtins/TokenTable/index.tsx';
import VideoPlayer from '/opt/buildhome/repo/.dumi/theme/builtins/VideoPlayer/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage } from 'dumi';
import { texts as $$contentTexts } from '/opt/buildhome/repo/components/use-x-chat/index.en-US.md?type=text';

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  return (
    <DumiPage>
      <Suspense fallback={<LoadingComponent />}>
        <><div className="markdown"><h2 id="when-to-use"><LocaleLink aria-hidden="true" tabIndex="-1" href="#when-to-use" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"When To Use"}</h2><p>{$$contentTexts[0].value}</p><h2 id="examples"><LocaleLink aria-hidden="true" tabIndex="-1" href="#examples" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"Examples"}</h2></div><DemoWrapper items={[{
  "demo": {
    "id": "components-use-x-chat-demo-basic"
  },
  "previewerProps": {
    "title": "Basic",
    "filename": "components/use-x-chat/demo/basic.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^19.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^18.0.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@prettier/sync": "^0.6.1",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^24.0.3",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.25.1",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^1.1.2",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "^4.5.4",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^18.0.1",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^30.0.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^16.1.2",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^30.0.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "^7.1.11",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.34.2",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^38.0.0",
      "stylelint-prettier": "^5.0.2",
      "tar": "^7.4.3",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "pkgPeerDependencies": {
      "antd": "^5.20.3",
      "react": ">=18.0.0",
      "react-dom": ">=18.0.0"
    },
    "jsx": "var __awaiter =\n  (this && this.__awaiter) ||\n  function (thisArg, _arguments, P, generator) {\n    function adopt(value) {\n      return value instanceof P\n        ? value\n        : new P(function (resolve) {\n            resolve(value);\n          });\n    }\n    return new (P || (P = Promise))(function (resolve, reject) {\n      function fulfilled(value) {\n        try {\n          step(generator.next(value));\n        } catch (e) {\n          reject(e);\n        }\n      }\n      function rejected(value) {\n        try {\n          step(generator['throw'](value));\n        } catch (e) {\n          reject(e);\n        }\n      }\n      function step(result) {\n        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);\n      }\n      step((generator = generator.apply(thisArg, _arguments || [])).next());\n    });\n  };\nimport { UserOutlined } from '@ant-design/icons';\nimport { Bubble, Sender, useXAgent, useXChat } from '@ant-design/x';\nimport { Flex } from 'antd';\nimport React from 'react';\nconst sleep = () => new Promise(resolve => setTimeout(resolve, 1000));\nconst roles = {\n  ai: {\n    placement: 'start',\n    avatar: { icon: <UserOutlined />, style: { background: '#fde3cf' } },\n    typing: { step: 5, interval: 20 },\n    style: {\n      maxWidth: 600,\n    },\n  },\n  local: {\n    placement: 'end',\n    avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },\n  },\n};\nlet mockSuccess = false;\nconst App = () => {\n  const [content, setContent] = React.useState('');\n  // Agent for request\n  const [agent] = useXAgent({\n    request: (_a, _b) =>\n      __awaiter(void 0, [_a, _b], void 0, function* ({ message }, { onSuccess, onError }) {\n        yield sleep();\n        mockSuccess = !mockSuccess;\n        if (mockSuccess) {\n          onSuccess([`Mock success return. You said: ${message}`]);\n        }\n        onError(new Error('Mock request failed'));\n      }),\n  });\n  // Chat messages\n  const { onRequest, messages } = useXChat({\n    agent,\n    requestPlaceholder: 'Waiting...',\n    requestFallback: 'Mock failed return. Please try again later.',\n  });\n  return (\n    <Flex vertical gap=\"middle\">\n      <Bubble.List\n        roles={roles}\n        style={{ maxHeight: 300 }}\n        items={messages.map(({ id, message, status }) => ({\n          key: id,\n          loading: status === 'loading',\n          role: status === 'local' ? 'local' : 'ai',\n          content: message,\n        }))}\n      />\n      <Sender\n        loading={agent.isRequesting()}\n        value={content}\n        onChange={setContent}\n        onSubmit={nextContent => {\n          onRequest(nextContent);\n          setContent('');\n        }}\n      />\n    </Flex>\n  );\n};\nexport default App;\n",
    "description": "<p>Basic usage.</p>"
  }
}, {
  "demo": {
    "id": "components-use-x-chat-demo-stream"
  },
  "previewerProps": {
    "title": "Streaming",
    "filename": "components/use-x-chat/demo/stream.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^19.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^18.0.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@prettier/sync": "^0.6.1",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^24.0.3",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.25.1",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^1.1.2",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "^4.5.4",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^18.0.1",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^30.0.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^16.1.2",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^30.0.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "^7.1.11",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.34.2",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^38.0.0",
      "stylelint-prettier": "^5.0.2",
      "tar": "^7.4.3",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "pkgPeerDependencies": {
      "antd": "^5.20.3",
      "react": ">=18.0.0",
      "react-dom": ">=18.0.0"
    },
    "jsx": "var __awaiter =\n  (this && this.__awaiter) ||\n  function (thisArg, _arguments, P, generator) {\n    function adopt(value) {\n      return value instanceof P\n        ? value\n        : new P(function (resolve) {\n            resolve(value);\n          });\n    }\n    return new (P || (P = Promise))(function (resolve, reject) {\n      function fulfilled(value) {\n        try {\n          step(generator.next(value));\n        } catch (e) {\n          reject(e);\n        }\n      }\n      function rejected(value) {\n        try {\n          step(generator['throw'](value));\n        } catch (e) {\n          reject(e);\n        }\n      }\n      function step(result) {\n        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);\n      }\n      step((generator = generator.apply(thisArg, _arguments || [])).next());\n    });\n  };\nimport { UserOutlined } from '@ant-design/icons';\nimport { Bubble, Sender, useXAgent, useXChat } from '@ant-design/x';\nimport { Flex } from 'antd';\nimport React from 'react';\nconst roles = {\n  ai: {\n    placement: 'start',\n    avatar: { icon: <UserOutlined />, style: { background: '#fde3cf' } },\n  },\n  local: {\n    placement: 'end',\n    avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },\n  },\n};\nconst App = () => {\n  const [content, setContent] = React.useState('');\n  // Agent for request\n  const [agent] = useXAgent({\n    request: (_a, _b) =>\n      __awaiter(void 0, [_a, _b], void 0, function* ({ message }, { onSuccess, onUpdate }) {\n        const fullContent = `Streaming output instead of Bubble typing effect. You typed: ${message}`;\n        let currentContent = '';\n        const id = setInterval(() => {\n          currentContent = fullContent.slice(0, currentContent.length + 2);\n          onUpdate(currentContent);\n          if (currentContent === fullContent) {\n            clearInterval(id);\n            onSuccess([fullContent]);\n          }\n        }, 100);\n      }),\n  });\n  // Chat messages\n  const { onRequest, messages } = useXChat({\n    agent,\n  });\n  return (\n    <Flex vertical gap=\"middle\">\n      <Bubble.List\n        roles={roles}\n        style={{ maxHeight: 300 }}\n        items={messages.map(({ id, message, status }) => ({\n          key: id,\n          role: status === 'local' ? 'local' : 'ai',\n          content: message,\n        }))}\n      />\n      <Sender\n        loading={agent.isRequesting()}\n        value={content}\n        onChange={setContent}\n        onSubmit={nextContent => {\n          onRequest(nextContent);\n          setContent('');\n        }}\n      />\n    </Flex>\n  );\n};\nexport default App;\n",
    "description": "<p>Update content with stream output.</p>"
  }
}, {
  "demo": {
    "id": "components-use-x-chat-demo-suggestions"
  },
  "previewerProps": {
    "title": "Multiple Suggestion",
    "filename": "components/use-x-chat/demo/suggestions.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^19.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^18.0.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@prettier/sync": "^0.6.1",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^24.0.3",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.25.1",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^1.1.2",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "^4.5.4",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^18.0.1",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^30.0.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^16.1.2",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^30.0.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "^7.1.11",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.34.2",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^38.0.0",
      "stylelint-prettier": "^5.0.2",
      "tar": "^7.4.3",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "pkgPeerDependencies": {
      "antd": "^5.20.3",
      "react": ">=18.0.0",
      "react-dom": ">=18.0.0"
    },
    "jsx": "var __awaiter =\n  (this && this.__awaiter) ||\n  function (thisArg, _arguments, P, generator) {\n    function adopt(value) {\n      return value instanceof P\n        ? value\n        : new P(function (resolve) {\n            resolve(value);\n          });\n    }\n    return new (P || (P = Promise))(function (resolve, reject) {\n      function fulfilled(value) {\n        try {\n          step(generator.next(value));\n        } catch (e) {\n          reject(e);\n        }\n      }\n      function rejected(value) {\n        try {\n          step(generator['throw'](value));\n        } catch (e) {\n          reject(e);\n        }\n      }\n      function step(result) {\n        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);\n      }\n      step((generator = generator.apply(thisArg, _arguments || [])).next());\n    });\n  };\nimport { SmileOutlined, UserOutlined } from '@ant-design/icons';\nimport { Bubble, Prompts, Sender, useXAgent, useXChat } from '@ant-design/x';\nimport { Flex } from 'antd';\nimport React from 'react';\nconst sleep = () => new Promise(resolve => setTimeout(resolve, 1000));\nconst roles = {\n  user: {\n    placement: 'end',\n    avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },\n  },\n  text: {\n    placement: 'start',\n    avatar: { icon: <UserOutlined />, style: { background: '#fde3cf' } },\n  },\n  suggestion: {\n    placement: 'start',\n    avatar: { icon: <UserOutlined />, style: { visibility: 'hidden' } },\n    variant: 'borderless',\n    messageRender: content => (\n      <Prompts\n        vertical\n        items={content.map(text => ({\n          key: text,\n          icon: <SmileOutlined style={{ color: '#FAAD14' }} />,\n          description: text,\n        }))}\n      />\n    ),\n  },\n};\nconst App = () => {\n  const [content, setContent] = React.useState('');\n  // Agent for request\n  const [agent] = useXAgent({\n    request: (_a, _b) =>\n      __awaiter(void 0, [_a, _b], void 0, function* ({ message }, { onSuccess }) {\n        yield sleep();\n        const { content } = message || {};\n        onSuccess([\n          {\n            type: 'ai',\n            list: [\n              {\n                type: 'text',\n                content: `Do you want?`,\n              },\n              {\n                type: 'suggestion',\n                content: [`Look at: ${content}`, `Search: ${content}`, `Try: ${content}`],\n              },\n            ],\n          },\n        ]);\n      }),\n  });\n  // Chat messages\n  const { onRequest, parsedMessages } = useXChat({\n    agent,\n    defaultMessages: [\n      {\n        id: 'init',\n        message: {\n          type: 'ai',\n          content: 'Hello, what can I do for you?',\n        },\n        status: 'success',\n      },\n    ],\n    requestPlaceholder: {\n      type: 'ai',\n      content: 'Waiting...',\n    },\n    // Convert AgentMessage to BubbleMessage\n    parser: agentMessages => {\n      const list = agentMessages.content ? [agentMessages] : agentMessages.list;\n      return (list || []).map(msg => ({\n        role: msg.type,\n        content: msg.content,\n      }));\n    },\n  });\n  return (\n    <Flex vertical gap=\"middle\">\n      <Bubble.List\n        roles={roles}\n        style={{ maxHeight: 300 }}\n        items={parsedMessages.map(({ id, message, status }) =>\n          Object.assign({ key: id, loading: status === 'loading' }, message),\n        )}\n      />\n      <Sender\n        loading={agent.isRequesting()}\n        value={content}\n        onChange={setContent}\n        onSubmit={nextContent => {\n          onRequest({\n            type: 'user',\n            content: nextContent,\n          });\n          setContent('');\n        }}\n      />\n    </Flex>\n  );\n};\nexport default App;\n",
    "description": "<p>Return multiple recommended contents by customizing the ability.</p>"
  }
}, {
  "demo": {
    "id": "components-use-x-chat-demo-model"
  },
  "previewerProps": {
    "title": "Model Access",
    "filename": "components/use-x-chat/demo/model.tsx",
    "pkgDependencyList": {
      "@ant-design/tools": "^19.0.2",
      "@ant-design/v5-patch-for-react-19": "^1.0.3",
      "@antv/gpt-vis": "^0.4.1",
      "@biomejs/biome": "^1.9.0",
      "@codecov/webpack-plugin": "^1.4.0",
      "@codesandbox/sandpack-react": "^2.19.8",
      "@emotion/react": "^11.13.5",
      "@emotion/server": "^11.11.0",
      "@happy-dom/jest-environment": "^18.0.1",
      "@ianvs/prettier-plugin-sort-imports": "^4.3.1",
      "@madccc/duplicate-package-checker-webpack-plugin": "^1.0.0",
      "@microflash/rehype-figure": "^2.1.1",
      "@npmcli/run-script": "^9.0.1",
      "@octokit/rest": "^21.0.2",
      "@petercatai/assistant": "^2.0.13",
      "@prettier/sync": "^0.6.1",
      "@qixian.cs/github-contributors-list": "^2.0.2",
      "@rc-component/father-plugin": "^2.0.4",
      "@rc-component/np": "^1.0.3",
      "@rc-component/trigger": "^2.2.3",
      "@size-limit/file": "^11.1.5",
      "@stackblitz/sdk": "^1.11.0",
      "@testing-library/dom": "^10.4.0",
      "@testing-library/jest-dom": "^6.5.0",
      "@testing-library/react": "^16.0.1",
      "@testing-library/user-event": "^14.5.2",
      "@types/adm-zip": "^0.5.5",
      "@types/ali-oss": "^6.16.11",
      "@types/cli-progress": "^3.11.6",
      "@types/fs-extra": "^11.0.4",
      "@types/gtag.js": "^0.0.20",
      "@types/http-server": "^0.12.4",
      "@types/inquirer": "^9.0.7",
      "@types/isomorphic-fetch": "^0.0.39",
      "@types/jest": "^29.5.13",
      "@types/jest-axe": "^3.5.9",
      "@types/jest-environment-puppeteer": "^5.0.6",
      "@types/jest-image-snapshot": "^6.4.0",
      "@types/jquery": "^3.5.30",
      "@types/jsdom": "^21.1.7",
      "@types/lodash": "^4.17.7",
      "@types/markdown-it": "^14.1.2",
      "@types/minimist": "^1.2.5",
      "@types/node": "^24.0.3",
      "@types/ora": "^3.2.0",
      "@types/pixelmatch": "^5.2.6",
      "@types/pngjs": "^6.0.5",
      "@types/prismjs": "^1.26.4",
      "@types/progress": "^2.0.7",
      "@types/qs": "^6.9.16",
      "@types/react": "^19.0.2",
      "@types/react-copy-to-clipboard": "^5.0.7",
      "@types/react-dom": "^19.0.2",
      "@types/react-highlight-words": "^0.20.0",
      "@types/react-resizable": "^3.0.8",
      "@types/semver": "^7.5.8",
      "@types/spinnies": "^0.5.3",
      "@types/tar": "^6.1.13",
      "@types/throttle-debounce": "^5.0.2",
      "@types/warning": "^3.0.3",
      "@umijs/fabric": "^4.0.1",
      "adm-zip": "^0.5.16",
      "ali-oss": "^6.21.0",
      "antd": "^5.25.1",
      "antd-style": "^3.6.3",
      "antd-token-previewer": "^2.0.8",
      "axios": "^1.7.7",
      "browserslist": "^4.23.3",
      "browserslist-to-esbuild": "^2.1.1",
      "chalk": "^5.4.1",
      "cheerio": "^1.0.0",
      "circular-dependency-plugin": "^5.2.2",
      "cli-progress": "^3.12.0",
      "copy-to-clipboard": "^3.3.3",
      "cross-env": "^7.0.3",
      "cross-fetch": "^4.0.0",
      "crypto": "^1.0.1",
      "dayjs": "^1.11.13",
      "dekko": "^0.2.1",
      "dumi": "^2.4.17",
      "dumi-plugin-color-chunk": "^1.1.2",
      "esbuild-loader": "^4.2.2",
      "fast-glob": "^3.3.2",
      "father": "^4.5.4",
      "fetch-jsonp": "^1.3.0",
      "fs-extra": "^11.2.0",
      "gh-pages": "^6.1.1",
      "glob": "^11.0.0",
      "happy-dom": "^18.0.1",
      "html2sketch": "^1.0.2",
      "http-server": "^14.1.1",
      "husky": "^9.1.6",
      "identity-obj-proxy": "^3.0.0",
      "immer": "^10.1.1",
      "inquirer": "^12.1.0",
      "is-ci": "^4.1.0",
      "isomorphic-fetch": "^3.0.0",
      "jest": "^29.7.0",
      "jest-axe": "^10.0.0",
      "jest-canvas-mock": "^2.5.2",
      "jest-environment-node": "^30.0.0",
      "jest-image-snapshot": "^6.4.0",
      "jest-puppeteer": "^11.0.0",
      "jquery": "^3.7.1",
      "jsdom": "^26.0.0",
      "jsonml-to-react-element": "^1.1.11",
      "jsonml.js": "^0.1.0",
      "lint-staged": "^16.1.2",
      "lodash": "^4.17.21",
      "lottie-web": "^5.12.2",
      "lunar-typescript": "^1.7.5",
      "lz-string": "^1.5.0",
      "markdown-it": "^14.1.0",
      "minimist": "^1.2.8",
      "mockdate": "^3.0.5",
      "node-fetch": "^3.3.2",
      "node-notifier": "^10.0.1",
      "open": "^10.1.0",
      "ora": "^8.1.0",
      "pixelmatch": "^7.1.0",
      "pngjs": "^7.0.0",
      "prettier": "^3.3.3",
      "prettier-plugin-jsdoc": "^1.3.0",
      "pretty-format": "^30.0.0",
      "prismjs": "^1.29.0",
      "puppeteer": "^24.0.0",
      "qs": "^6.13.0",
      "rc-drawer": "^8.0.0",
      "rc-footer": "^0.6.8",
      "rc-resize-observer": "^1.4.0",
      "rc-virtual-list": "^3.14.5",
      "react": "^19.0.0",
      "react-copy-to-clipboard": "^5.1.0",
      "react-dom": "^19.0.0",
      "react-highlight-words": "^0.20.0",
      "react-infinite-scroll-component": "^6.1.0",
      "react-intersection-observer": "^9.13.1",
      "react-intl": "^7.1.11",
      "react-resizable": "^3.0.5",
      "react-router-dom": "^7.0.1",
      "react-sticky-box": "^2.0.5",
      "regenerator-runtime": "^0.14.1",
      "rehype-stringify": "^10.0.0",
      "remark": "^15.0.1",
      "remark-cli": "^12.0.1",
      "remark-gfm": "^4.0.0",
      "remark-lint": "^10.0.0",
      "remark-lint-no-undefined-references": "^5.0.0",
      "remark-preset-lint-recommended": "^7.0.0",
      "remark-rehype": "^11.1.0",
      "scroll-into-view-if-needed": "^3.1.0",
      "semver": "^7.6.3",
      "sharp": "^0.34.2",
      "simple-git": "^3.26.0",
      "size-limit": "^11.1.5",
      "spinnies": "^0.5.1",
      "stylelint": "^16.9.0",
      "stylelint-config-rational-order": "^0.1.2",
      "stylelint-config-standard": "^38.0.0",
      "stylelint-prettier": "^5.0.2",
      "tar": "^7.4.3",
      "tsx": "^4.19.1",
      "typedoc": "^0.28.0",
      "typescript": "~5.8.2",
      "vanilla-jsoneditor": "^3.0.0",
      "web-streams-polyfill": "^4.0.0",
      "webpack": "^5.94.0",
      "webpack-bundle-analyzer": "^4.10.2",
      "@ant-design/colors": "^7.1.0",
      "@ant-design/cssinjs": "^1.21.1",
      "@ant-design/cssinjs-utils": "^1.1.0",
      "@ant-design/fast-color": "^2.0.6",
      "@ant-design/icons": "^5.4.0",
      "@babel/runtime": "^7.25.6",
      "classnames": "^2.5.1",
      "rc-motion": "^2.9.2",
      "rc-util": "^5.43.0"
    },
    "pkgPeerDependencies": {
      "antd": "^5.20.3",
      "react": ">=18.0.0",
      "react-dom": ">=18.0.0"
    },
    "jsx": "import { UserOutlined } from '@ant-design/icons';\nimport { Bubble, Sender, useXAgent, useXChat } from '@ant-design/x';\nimport { Flex } from 'antd';\nimport React, { useRef } from 'react';\n/**\n * 🔔 Please replace the BASE_URL, PATH, MODEL, API_KEY with your own values.\n */\nconst BASE_URL = 'https://api.x.ant.design/api/llm_siliconflow_deepSeek-r1-distill-1wen-7b';\n/**\n * 🔔 The MODEL is fixed in the current request, please replace it with your BASE_UR and MODEL\n */\nconst MODEL = 'DeepSeek-R1-Distill-Qwen-7B';\n/**\n * 🔔 the API_KEY is a placeholder indicator interface that has a built-in real API_KEY\n */\nconst API_KEY = 'Bearer sk-xxxxxxxxxxxxxxxxxxxx';\nconst roles = {\n  assistant: {\n    placement: 'start',\n    avatar: { icon: <UserOutlined />, style: { background: '#fde3cf' } },\n  },\n  user: {\n    placement: 'end',\n    avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },\n  },\n};\nconst App = () => {\n  const [content, setContent] = React.useState('');\n  const [agent] = useXAgent({\n    baseURL: BASE_URL,\n    model: MODEL,\n    dangerouslyApiKey: API_KEY,\n    /** 🔥🔥 Its dangerously! */\n  });\n  const abortController = useRef(null);\n  // Chat messages\n  const { onRequest, messages } = useXChat({\n    agent,\n    requestFallback: (_, { error }) => {\n      if (error.name === 'AbortError') {\n        return {\n          content: 'Request is aborted',\n          role: 'assistant',\n        };\n      }\n      return {\n        content: 'Request failed, please try again!',\n        role: 'assistant',\n      };\n    },\n    requestPlaceholder: () => {\n      return {\n        content: 'Please wait...',\n        role: 'assistant',\n      };\n    },\n    transformMessage: info => {\n      var _a, _b, _c, _d, _e, _f, _g;\n      const { originMessage, chunk } = info || {};\n      let currentContent = '';\n      let currentThink = '';\n      try {\n        if (\n          (chunk === null || chunk === void 0 ? void 0 : chunk.data) &&\n          !(chunk === null || chunk === void 0 ? void 0 : chunk.data.includes('DONE'))\n        ) {\n          const message = JSON.parse(chunk === null || chunk === void 0 ? void 0 : chunk.data);\n          currentThink =\n            ((_c =\n              (_b =\n                (_a = message === null || message === void 0 ? void 0 : message.choices) === null ||\n                _a === void 0\n                  ? void 0\n                  : _a[0]) === null || _b === void 0\n                ? void 0\n                : _b.delta) === null || _c === void 0\n              ? void 0\n              : _c.reasoning_content) || '';\n          currentContent =\n            ((_f =\n              (_e =\n                (_d = message === null || message === void 0 ? void 0 : message.choices) === null ||\n                _d === void 0\n                  ? void 0\n                  : _d[0]) === null || _e === void 0\n                ? void 0\n                : _e.delta) === null || _f === void 0\n              ? void 0\n              : _f.content) || '';\n        }\n      } catch (error) {\n        console.error(error);\n      }\n      let content = '';\n      if (\n        !(originMessage === null || originMessage === void 0 ? void 0 : originMessage.content) &&\n        currentThink\n      ) {\n        content = `<think>${currentThink}`;\n      } else if (\n        ((_g =\n          originMessage === null || originMessage === void 0 ? void 0 : originMessage.content) ===\n          null || _g === void 0\n          ? void 0\n          : _g.includes('<think>')) &&\n        !(originMessage === null || originMessage === void 0\n          ? void 0\n          : originMessage.content.includes('</think>')) &&\n        currentContent\n      ) {\n        content = `${originMessage === null || originMessage === void 0 ? void 0 : originMessage.content}</think>${currentContent}`;\n      } else {\n        content = `${(originMessage === null || originMessage === void 0 ? void 0 : originMessage.content) || ''}${currentThink}${currentContent}`;\n      }\n      return {\n        content: content,\n        role: 'assistant',\n      };\n    },\n    resolveAbortController: controller => {\n      abortController.current = controller;\n    },\n  });\n  return (\n    <Flex vertical gap=\"middle\">\n      <Bubble.List\n        roles={roles}\n        style={{ maxHeight: 300 }}\n        items={messages.map(({ id, message }) => ({\n          key: id,\n          role: message.role,\n          content: message.content,\n        }))}\n      />\n      <Sender\n        loading={agent.isRequesting()}\n        value={content}\n        onCancel={() => {\n          var _a, _b;\n          (_b =\n            (_a =\n              abortController === null || abortController === void 0\n                ? void 0\n                : abortController.current) === null || _a === void 0\n              ? void 0\n              : _a.abort) === null || _b === void 0\n            ? void 0\n            : _b.call(_a);\n        }}\n        onChange={setContent}\n        onSubmit={nextContent => {\n          onRequest({\n            stream: true,\n            message: {\n              role: 'user',\n              content: nextContent,\n            },\n          });\n          setContent('');\n        }}\n      />\n    </Flex>\n  );\n};\nexport default App;\n",
    "description": "<p>Access to cloud service platform,can send messages, process data, abort stream.</p>"
  }
}]} /><div className="markdown"><h2 id="api"><LocaleLink aria-hidden="true" tabIndex="-1" href="#api" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"API"}</h2><SourceCode lang="tsx">{$$contentTexts[1].value}</SourceCode><h3 id="xchatconfig"><LocaleLink aria-hidden="true" tabIndex="-1" href="#xchatconfig" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"XChatConfig"}</h3><Table className="component-api-table"><thead><tr><th>{$$contentTexts[2].value}</th><th>{$$contentTexts[3].value}</th><th>{$$contentTexts[4].value}</th><th>{$$contentTexts[5].value}</th><th>{$$contentTexts[6].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[7].value}</td><td><code>{$$contentTexts[8].value}</code>{$$contentTexts[9].value}<code>{$$contentTexts[10].value}</code>{$$contentTexts[11].value}<code>{$$contentTexts[12].value}</code>{$$contentTexts[13].value}</td><td>{$$contentTexts[14].value}</td><td>{$$contentTexts[15].value}</td><td>{$$contentTexts[16].value}</td></tr><tr><td>{$$contentTexts[17].value}</td><td>{$$contentTexts[18].value}</td><td>{$$contentTexts[19].value}</td><td>{$$contentTexts[20].value}</td><td>{$$contentTexts[21].value}</td></tr><tr><td>{$$contentTexts[22].value}</td><td>{$$contentTexts[23].value}</td><td>{$$contentTexts[24].value}</td><td>{$$contentTexts[25].value}</td><td>{$$contentTexts[26].value}</td></tr><tr><td>{$$contentTexts[27].value}</td><td>{$$contentTexts[28].value}</td><td>{$$contentTexts[29].value}</td><td>{$$contentTexts[30].value}</td><td>{$$contentTexts[31].value}</td></tr><tr><td>{$$contentTexts[32].value}</td><td>{$$contentTexts[33].value}</td><td>{$$contentTexts[34].value}</td><td>{$$contentTexts[35].value}</td><td>{$$contentTexts[36].value}</td></tr><tr><td>{$$contentTexts[37].value}</td><td>{$$contentTexts[38].value}<code>{$$contentTexts[39].value}</code>{$$contentTexts[40].value}<code>{$$contentTexts[41].value}</code></td><td>{$$contentTexts[42].value}</td><td>{$$contentTexts[43].value}</td><td>{$$contentTexts[44].value}</td></tr></tbody></Table><h3 id="xchatconfigreturntype"><LocaleLink aria-hidden="true" tabIndex="-1" href="#xchatconfigreturntype" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"XChatConfigReturnType"}</h3><Table className="component-api-table"><thead><tr><th>{$$contentTexts[45].value}</th><th>{$$contentTexts[46].value}</th><th>{$$contentTexts[47].value}</th><th>{$$contentTexts[48].value}</th><th>{$$contentTexts[49].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[50].value}</td><td>{$$contentTexts[51].value}</td><td>{$$contentTexts[52].value}</td><td>{$$contentTexts[53].value}</td><td>{$$contentTexts[54].value}</td></tr><tr><td>{$$contentTexts[55].value}</td><td>{$$contentTexts[56].value}<code>{$$contentTexts[57].value}</code>{$$contentTexts[58].value}</td><td>{$$contentTexts[59].value}</td><td>{$$contentTexts[60].value}</td><td>{$$contentTexts[61].value}</td></tr><tr><td>{$$contentTexts[62].value}</td><td>{$$contentTexts[63].value}<code>{$$contentTexts[64].value}</code>{$$contentTexts[65].value}<code>{$$contentTexts[66].value}</code>{$$contentTexts[67].value}</td><td>{$$contentTexts[68].value}</td><td>{$$contentTexts[69].value}</td><td>{$$contentTexts[70].value}</td></tr><tr><td>{$$contentTexts[71].value}</td><td>{$$contentTexts[72].value}</td><td>{$$contentTexts[73].value}</td><td>{$$contentTexts[74].value}</td><td>{$$contentTexts[75].value}</td></tr></tbody></Table><h3 id="requestparams"><LocaleLink aria-hidden="true" tabIndex="-1" href="#requestparams" sourceType="a"><span className="icon icon-link" /></LocaleLink>{"RequestParams"}</h3><p>{$$contentTexts[76].value}<LocaleLink to="/components/x-request#xrequestparams" sourceType="Link">{$$contentTexts[77].value}</LocaleLink>{$$contentTexts[78].value}</p><Table className="component-api-table"><thead><tr><th>{$$contentTexts[79].value}</th><th>{$$contentTexts[80].value}</th><th>{$$contentTexts[81].value}</th><th>{$$contentTexts[82].value}</th><th>{$$contentTexts[83].value}</th></tr></thead><tbody><tr><td>{$$contentTexts[84].value}</td><td>{$$contentTexts[85].value}</td><td>{$$contentTexts[86].value}</td><td>{$$contentTexts[87].value}</td><td>{$$contentTexts[88].value}</td></tr></tbody></Table></div></>
      </Suspense>
    </DumiPage>
  )
}

export default DumiMarkdownContent;